export const Secrets = {
  apiKey: '00132344-f6c7-4fc2-8655-fac279d377c5',
  firebaseKey: 'AIzaSyAGg0J4yxwF3ojR9lmFG-eHVSP38wBv3Ps',
};

export const FirebaseConfig = {
  apiKey: Secrets.firebaseKey,
  authDomain: 'kekeno-site.firebaseapp.com',
  projectId: 'kekeno-site',
  storageBucket: 'kekeno-site.firebasestorage.app',
  messagingSenderId: '1049457768336',
  appId: '1:1049457768336:web:78cc7661195f9aa4afa515',
  measurementId: 'G-946P4T24Z6',
};
